import { CruiseCardVariant } from 'components/CruiseCard';
import { MapCruiseCardLabel as MapCruiseCardLabelComponent, MapCruiseCardLabelContainer } from './MapCruiseCard.styled';
import { MapCruiseCardLabelTypes } from './MapCruiseCard.types';

function MapCruiseCardLabel({ labelFunction, title, packageId, className = '' }: MapCruiseCardLabelTypes) {
	return (
		<MapCruiseCardLabelContainer className={className}>
			<MapCruiseCardLabelComponent
				onClick={(e) => {
					e.stopPropagation();
					labelFunction(CruiseCardVariant.Map);
				}}
				className={className}
				data-testid={`cruise-view-port-map-button-${packageId}`}
			>
				{title}
			</MapCruiseCardLabelComponent>
		</MapCruiseCardLabelContainer>
	);
}

export default MapCruiseCardLabel;
